module.exports = __webpack_public_path__ + "img/certificate1.png?9ef4a608f70a7c17b8e0667cc1381586";